export const completionColorScheme = (completion: number) => {
   if (completion === 0) {
      return 'gray';
   } else if (completion <= 50) {
      return 'red';
   } else if (completion <= 85) {
      return 'yellow';
   } else {
      return 'green';
   }
};

export const courseTextColors = {
   gray: 'blueGray.600',
   red: 'red.500',
   yellow: 'yellow.500',
   green: 'green.400',
};

export const completionTextColor = (completion: number) => {
   return courseTextColors[completionColorScheme(completion)];
};
